var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-card"},[_c('div',{staticClass:"error-card-icon"},[_c('iconic',{attrs:{"name":_vm.icon || 'exclamation_triangle'}})],1),_c('div',{staticClass:"error-card-message",domProps:{"innerHTML":_vm._s(_vm.message)}}),_c('div',{staticClass:"error-card-options"})])
}
var staticRenderFns = []

export { render, staticRenderFns }